__turbopack_context__.v({
  "errorMessage": "ReferAFriend-module__1i-J4a__errorMessage",
  "message": "ReferAFriend-module__1i-J4a__message",
  "referButton": "ReferAFriend-module__1i-J4a__referButton",
  "referForm": "ReferAFriend-module__1i-J4a__referForm",
  "referFriendContainer": "ReferAFriend-module__1i-J4a__referFriendContainer",
  "referFriendDescription": "ReferAFriend-module__1i-J4a__referFriendDescription",
  "referFriendTitle": "ReferAFriend-module__1i-J4a__referFriendTitle",
  "referInput": "ReferAFriend-module__1i-J4a__referInput",
  "successMessage": "ReferAFriend-module__1i-J4a__successMessage",
});
